@if (parent.isSectionActive(name())) {<ng-content />}
